/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_SMART_LINKS,
  GET_SMART_LINKS_SUCCESS,
  GET_SMART_LINKS_ERROR,
  CLEAR_SMART_LINKS,
  GET_SMART_LINK,
  GET_SMART_LINK_SUCCESS,
  GET_SMART_LINK_ERROR,
  CLEAR_SMART_LINK,
  CREATE_SMART_LINK,
  CREATE_SMART_LINK_SUCCESS,
  CREATE_SMART_LINK_ERROR,
  UPDATE_SMART_LINK,
  UPDATE_SMART_LINK_SUCCESS,
  UPDATE_SMART_LINK_ERROR,
  DELETE_SMART_LINK,
  DELETE_SMART_LINK_SUCCESS,
  DELETE_SMART_LINK_ERROR,
  CLEAR_SMART_LINK_WAS_DELETED,
  GET_SMART_LINK_CLICKS,
  GET_SMART_LINK_CLICKS_SUCCESS,
  GET_SMART_LINK_CLICKS_ERROR,
  CLEAR_SMART_LINK_CLICKS,
  GET_ACTIVE_SMART_LINKS,
  GET_ACTIVE_SMART_LINKS_SUCCESS,
  GET_ACTIVE_SMART_LINKS_ERROR,
  CLEAR_ACTIVE_SMART_LINKS,
  SET_SMART_LINKS_QUERY,
  CLEAR_SMART_LINKS_QUERY_FILTER,
  SET_BACK_TO_SMART_LINKS_LIST,
  SET_BACK_TO_SMART_LINK_CLICK_HISTORY,
  SET_CURRENT_NAVIGATION_TAB,
} from 'src/actions/smartLinksActions';

const backToSmartLinksList = {
  smartLinks: [],
  query: {},
  active: false,
  comeBack: false,
  backToId: null,
};

const backToSmartLinkClickHistory = {
  smartLinkId: null,
  active: false,
  comeBack: false,
  scrollY: 0,
  clicksPage: 0,
};

const defaultQuery = {
  status: 'Active',
  sort: [],
  filters: {},
  page: 1,
  pageSize: 50,
  count: 0,
  search: '',
};

const initialState = {
  smartLinks: [],
  loading: false,
  query: { ...defaultQuery },
  currentNavigationTab: 'links',
  smartLinkDetails: {
    smartLink: {},
    smartLinkWasDeleted: false,
    loading: false,
  },
  clicks: {
    data: [],
    total: 0,
    loading: false,
  },
  activeSmartLinks: {
    data: [],
    loading: false,
  },
  backToSmartLinksList,
  backToSmartLinkClickHistory,
};

const smartLinksReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_SMART_LINKS: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_SMART_LINKS_SUCCESS: {
      return produce(state, (draft) => {
        draft.smartLinks = payload || [];
        draft.loading = false;
      });
    }

    case GET_SMART_LINKS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_SMART_LINKS: {
      return produce(state, (draft) => {
        draft.smartLinks = [];
      });
    }

    case GET_SMART_LINK:
    case CREATE_SMART_LINK:
    case UPDATE_SMART_LINK: {
      return produce(state, (draft) => {
        draft.smartLinkDetails.loading = true;
      });
    }

    case GET_SMART_LINK_SUCCESS: {
      return produce(state, (draft) => {
        draft.smartLinkDetails.smartLink = payload || {};
        draft.smartLinkDetails.loading = false;
      });
    }

    case GET_SMART_LINK_ERROR:
    case CREATE_SMART_LINK_SUCCESS:
    case CREATE_SMART_LINK_ERROR:
    case UPDATE_SMART_LINK_ERROR: {
      return produce(state, (draft) => {
        draft.smartLinkDetails.loading = false;
      });
    }

    case UPDATE_SMART_LINK_SUCCESS: {
      return produce(state, (draft) => {
        draft.smartLinkDetails.smartLink = payload || state.smartLinkDetails.smartLink;
        draft.smartLinkDetails.loading = false;
      });
    }

    case CLEAR_SMART_LINK: {
      return produce(state, (draft) => {
        draft.smartLinkDetails.smartLink = {};
      });
    }

    case DELETE_SMART_LINK: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.smartLinkDetails.loading = true;
      });
    }

    case DELETE_SMART_LINK_SUCCESS: {
      return produce(state, (draft) => {
        draft.smartLinkDetails.loading = false;
        draft.loading = false;
        draft.smartLinkDetails.smartLinkWasDeleted = true;
      });
    }

    case DELETE_SMART_LINK_ERROR: {
      return produce(state, (draft) => {
        draft.smartLinkDetails.loading = false;
        draft.loading = false;
      });
    }

    case CLEAR_SMART_LINK_WAS_DELETED: {
      return produce(state, (draft) => {
        draft.smartLinkDetails.smartLinkWasDeleted = false;
      });
    }

    case GET_SMART_LINK_CLICKS: {
      return produce(state, (draft) => {
        draft.clicks.loading = true;
      });
    }

    case GET_SMART_LINK_CLICKS_SUCCESS: {
      return produce(state, (draft) => {
        draft.clicks.data = payload?.clicks || [];
        draft.clicks.total = payload?.total || 0;
        draft.clicks.loading = false;
      });
    }

    case GET_SMART_LINK_CLICKS_ERROR: {
      return produce(state, (draft) => {
        draft.clicks.loading = false;
      });
    }

    case CLEAR_SMART_LINK_CLICKS: {
      return produce(state, (draft) => {
        draft.clicks.data = [];
        draft.clicks.total = 0;
      });
    }

    case GET_ACTIVE_SMART_LINKS: {
      return produce(state, (draft) => {
        draft.activeSmartLinks.loading = true;
      });
    }

    case GET_ACTIVE_SMART_LINKS_SUCCESS: {
      return produce(state, (draft) => {
        draft.activeSmartLinks.data = payload || [];
        draft.activeSmartLinks.loading = false;
      });
    }

    case GET_ACTIVE_SMART_LINKS_ERROR: {
      return produce(state, (draft) => {
        draft.activeSmartLinks.loading = false;
      });
    }

    case CLEAR_ACTIVE_SMART_LINKS: {
      return produce(state, (draft) => {
        draft.activeSmartLinks.data = [];
      });
    }

    case SET_SMART_LINKS_QUERY: {
      return produce(state, (draft) => {
        draft.query = payload ? {
          ...state.query,
          ...payload
        } : { ...defaultQuery };
      });
    }

    case CLEAR_SMART_LINKS_QUERY_FILTER: {
      return produce(state, (draft) => {
        draft.query.filters = {};
      });
    }

    case SET_BACK_TO_SMART_LINKS_LIST: {
      return produce(state, (draft) => {
        draft.backToSmartLinksList = payload ? {
          ...state.backToSmartLinksList,
          ...payload,
        } : backToSmartLinksList;
      });
    }

    case SET_BACK_TO_SMART_LINK_CLICK_HISTORY: {
      return produce(state, (draft) => {
        draft.backToSmartLinkClickHistory = payload ? {
          ...state.backToSmartLinkClickHistory,
          ...payload,
        } : backToSmartLinkClickHistory;
      });
    }

    case SET_CURRENT_NAVIGATION_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload !== false ? payload : 'links';
      });
    }

    default: {
      return state;
    }
  }
};

export default smartLinksReducer;
